const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	PanelBody,
	SelectControl,
	Disabled,
	ToggleControl
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/reservation", {
	title: __("Réservation", "wp-apidae"), // Block title.
	description: __("Affiche les moyens de réservations.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.ticket
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		telephone: {
			type: "boolean",
			default: true,
		},
		fax: {
			type: "boolean",
			default: true,
		},
		mel: {
			type: "boolean",
			default: true,
		},
		site_web_url: {
			type: "boolean",
			default: true,
		},
		page_facebook: {
			type: "boolean",
			default: true,
		},
		page_twitter: {
			type: "boolean",
			default: true,
		},
		tripadvisor: {
			type: "boolean",
			default: true,
		},
		show_labels: {
			type: "boolean",
			default: true,
		},
		show_title: {
			type: "boolean",
			default: true,
		},
		field_tag: {
			type: 'string',
			default: 'h2',
		},
		align: {
			type: 'string',
			default: '',
		},
	},

	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;
			const fieldsTags          = window.WpApidaeTemplateData.fieldsTags;

			return [
					<InspectorControls key={"inspector"}>
						<PanelBody>
						<ToggleControl
								label={ __( 'Téléphone' ) }
								checked={ attributes.telephone }
								onChange={ () => {
									props.setAttributes({ telephone: ! attributes.telephone });
								} }
							/>
							<ToggleControl
								label={ __( 'Fax' ) }
								checked={ attributes.fax }
								onChange={ () => {
									props.setAttributes({ fax: ! attributes.fax });
								} }
							/>
							<ToggleControl
								label={ __( 'Mel' ) }
								checked={ attributes.mel }
								onChange={ () => {
									props.setAttributes({ mel: ! attributes.mel });
								} }
							/>
							<ToggleControl
								label={ __( 'Site Web' ) }
								checked={ attributes.site_web_url }
								onChange={ () => {
									props.setAttributes({ site_web_url: ! attributes.site_web_url });
								} }
							/>
							<ToggleControl
								label={ __( 'Page Facebook' ) }
								checked={ attributes.page_facebook }
								onChange={ () => {
									props.setAttributes({ page_facebook: ! attributes.page_facebook });
								} }
							/>
							<ToggleControl
								label={ __( 'Page Twitter' ) }
								checked={ attributes.page_twitter }
								onChange={ () => {
									props.setAttributes({ page_twitter: ! attributes.page_twitter });
								} }
							/>
							<ToggleControl
								label={ __( 'Tripadvisor' ) }
								checked={ attributes.tripadvisor }
								onChange={ () => {
									props.setAttributes({ tripadvisor: ! attributes.tripadvisor });
								} }
							/>
						</PanelBody>
						<PanelBody title={__("Options")}>
						<ToggleControl
								label={ __( 'Afficher les titres' ) }
								checked={ attributes.show_labels }
								onChange={ () => {
									props.setAttributes({ show_labels: ! attributes.show_labels });
								} }
							/>
							<ToggleControl
								label={ __( 'Afficher un titre de section' ) }
								checked={ attributes.show_title }
								onChange={ () => {
									props.setAttributes({ show_title: ! attributes.show_title });
								} }
							/>
							{ true === attributes.show_title &&
							<SelectControl
							label={ __( 'Balise à utiliser' ) }
							value={ attributes.field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									field_tag: newValue,
								});
							}}
						/>}
						</PanelBody>
					</InspectorControls>
				,
						<Disabled>
						<ServerSideRender
							block="wp-apidae/reservation"
							attributes={attributes}
							urlQueryArgs={{
							settings:template
						}}/>
					</Disabled>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
